export default __webpack_public_path__ + "static/media/DTU.9e59eb90.jpg";